import { useTranslation } from "react-i18next";
import AboutData from "../../../data/global/about.json";

const AboutService = () => {
    const { t, i18n } = useTranslation();
    const currenLanguage = i18n.language;
    return (
        <div className="service-area">
            <div className="container">
                <div className="row">
                    <div
                        className="col-lg-8 col-xl-8 mb-sm-50 mb-md-70"
                        data-aos="fade-up"
                    >
                        <h2 className="title">
                            {AboutData[0].title[currenLanguage]}
                        </h2>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: AboutData[0].excerpt[currenLanguage],
                            }}
                        />
                    </div>
                    <div
                        className="col-lg-4 col-xl-3 offset-xl-1"
                        data-aos="fade-up"
                        data-aos-delay="300"
                    >
                        <h2 className="title">
                            {AboutData[1].title[currenLanguage]}
                        </h2>
                        <ul>
                            {AboutData[1].pagelinkText[currenLanguage] &&
                                AboutData[1].pagelinkText[currenLanguage].map(
                                    (single, key) => {
                                        return <li key={key}>{single}</li>;
                                    }
                                )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutService;
